/**
 * Converts two numbers to an object.
 * @param {number} number1 - The first number.
 * @param {number} number2 - The second number.
 * @returns {object} An object containing numeric values for 'regular' and 'special'.
 */
export function createObjectFromNumbers(number1, number2) {
  const result = {
    regular: number1,
    special: number2,
  };

  return result;
}
